<template>
  <div class="text-center">
    <v-bottom-sheet v-model="sheet" persistent>
      <template v-slot:activator="{ on, attrs }">
        <div>
          <!--          <page-header></page-header>-->
          <!-- 제목 -->
          <v-row class="title-wrap">
            <v-col
              cols="12"
              class="icon-title word-type-txt pb-4 d-flex justify-space-between"
            >
              <div>
                <icon-edit :width="24" :height="24" />추가옵션을 입력해 주세요.
                <v-btn
                  class="title-tooltip"
                  icon
                  color="black"
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <!-- 휴직기간-->
          <div class="d-flex justify-center">
            <v-card class="cont-area">
              <v-card-title class="cont-title"
                ><div class="title">휴직기간</div>
                <!-- label 선택적 사용
                <div class="label-group">
                  <div class="d-inline pa-1 label">label</div>
                  <div class="d-inline pa-1 label">label</div>
                </div>
                -->
              </v-card-title>
              <v-card-text class="date">2009-01-01 ~ 2023-12-27</v-card-text>
              <v-card-text class="text"
                >복직예정일은 <span>30</span>입니다.</v-card-text
              >
            </v-card>
          </div>
          <!-- 메뉴 -->
          <div class="apply-list px-6">
            <v-text-field
              class="bottom--box"
              append-icon="mdi-chevron-right"
              label="대상자명"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
            <v-text-field label="생년월일"></v-text-field>
            <v-text-field label="휴직사유"></v-text-field>
            <v-file-input
              label="첨부파일"
              counter
              multiple
              show-size
              append-icon="mdi-plus-marker"
            ></v-file-input>
          </div>
          <!--하단버튼-->
          <v-bottom-navigation
            v-model="value"
            :input-value="active"
            fixed
            scroll-threshold="500"
            height="96"
          >
            <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
              <v-col cols="12">
                <v-btn
                  block
                  elevation="0"
                  class="btn-fixed btn-blue"
                  @click="$emit('goApplMenuList')"
                >
                  <span class="white--text">다음</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-bottom-navigation>
        </div>
      </template>
      <!-- 하단시트 -->
      <v-sheet class="bottom-sheet-box">
        <div class="sheet-title">대상자명</div>
        <div>본인</div>
        <div>배우자</div>
        <!--v-btn class="mt-6" text color="error" @click="sheet = !sheet">
            동의하고 시작하기
          </!--v-btn-->
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';
import IconEdit from '@/assets/customIcon/IconEdit.vue';

export default {
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },
  components: {
    //PageHeader,
    IconEdit,
  },

  data: () => ({
    sheet: false,
  }),
};
</script>
